
const testimonialSwipers = document.querySelectorAll(".testimonial-slider-swiper")

if(testimonialSwipers) {
  testimonialSwipers.forEach(slider => {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.testimonial-swiper-button-next',
        prevEl: '.testimonial-swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      }
    })
  })
}